/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateFamilyResponse } from '../models/CreateFamilyResponse';
import type { GetAllFamilyMembersResponse } from '../models/GetAllFamilyMembersResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FamilyControllerService {
    /**
     * @param requestBody Create family members
     * @param propertyId
     * @returns CreateFamilyResponse Response for successfully created family member
     * @throws ApiError
     */
    public static familyControllerCreateFamily(
        requestBody: Array<{
            /**
             * Unique ID of the family member
             */
            id?: string;
            /**
             * Full name of the family member
             */
            name: string;
            /**
             * Relation with the family head
             */
            relationship: string;
            /**
             * Occupation of the property owner or resident
             */
            scopeOccupation?: Record<string, any>;
            /**
             * Date of birth
             */
            dob?: string;
            /**
             * Date of transaction
             */
            dot?: string;
            /**
             * Birthplace of the family member
             */
            birthPlace?: string;
            /**
             * Problems being faced by the family member
             */
            problemFacing: Array<string>;
        }>,
        propertyId?: string,
    ): CancelablePromise<CreateFamilyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v0/api/family',
            query: {
                'propertyId': propertyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param propertyId
     * @returns GetAllFamilyMembersResponse Get all family members response
     * @throws ApiError
     */
    public static familyControllerGetFamily(
        propertyId?: string,
    ): CancelablePromise<GetAllFamilyMembersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/family',
            query: {
                'propertyId': propertyId,
            },
        });
    }
}
